<template>
	<div style="height: 100%;">
		<div class="comp">
			<div class="L">
				<div class="LItem" :class="curNavIndex===0?'active':''" @click="changeCurNavIndex(0)">
					<div class="navLabel">商品</div> <div class="navValue">{{count.cartInfoGoodsCount}}</div>
				</div>
				<div class="LItem" :class="curNavIndex===1?'active':''" @click="changeCurNavIndex(1)">
					<div class="navLabel">活体</div> <div class="navValue">{{count.cartInfoLivingCount}}</div>
				</div>
			</div>
			<div class="R">
				<!-- 商品 商品 商品 商品 商品 商品 商品 商品 商品 商品 商品 商品 商品  -->
				<div class="panel" v-show="curNavIndex===0">
					<div class="searchLine">
						<div class="searchLineL">
							<!-- <div class="searchItem" :class="curTab0NavIndex===0?'active':''" @click="changeCurTab0NavIndex(0)">
								<span>最新发布</span>
								<span v-if="curTab0NavIndex===0" class="searchItemActiveBar"></span>
							</div> -->
						</div>
						<div class="searchLineR">
							<el-input v-model="search0.keyword" @keyup.enter.native="changeSearch0" placeholder="请输入关键字"></el-input>
						</div>
					</div>
					<div class="list" v-if="$public.isNull(tableData0)" style="background-color: #fff;">
						<div style="padding-top:60px;text-align: center;">暂无数据</div>
					</div>
					<div class="list" v-else>
						<el-table :data="tableData0" >
							<el-table-column prop="no" label="序号" width="50">
								<template slot-scope="scope">
									{{scope.$index+1}}
								</template>
							</el-table-column>
							<el-table-column label="图片" width="60" >
								<template slot-scope="scope">
									<img :src="scope.row.image" style="max-width:40px;max-height:40px;"/>
								</template>
							</el-table-column>
							<el-table-column label="名称"  >
								<template slot-scope="scope">
									{{scope.row.goodsInfo&&scope.row.goodsInfo.goodsName}}
								</template>
							</el-table-column>
							<el-table-column label="规格" width="100" >
								<template slot-scope="scope">
									{{scope.row.goodsInfo&&scope.row.goodsInfo.skuName}}
								</template>
							</el-table-column>
							<el-table-column label="价格"  width="100">
								<template slot-scope="scope">
									{{scope.row.price}}
								</template>
							</el-table-column>
							<el-table-column label="数量"  width="100">
								<template slot-scope="scope">
									{{scope.row.num}}
								</template>
							</el-table-column>
							<el-table-column label="添加时间" width="160">
								<template slot-scope="scope">
									{{scope.row.createTime}}
								</template>
							</el-table-column>
						</el-table>
						<div class="pagePosi">
							<page style="padding:10px 0;" :page="page0.page" :total="page0.total" @change="changePage0"></page>
						</div>
					</div>
				</div>
				<!-- 活体 活体 活体 活体 活体 活体 活体 活体 活体 活体 活体 活体 活体 活体 活体 活体   -->
				<div class="panel" v-show="curNavIndex===1">
					<div class="searchLine">
						<div class="searchLineL">
							<!-- <div class="searchItem" :class="curTab0NavIndex===0?'active':''" @click="changeCurTab0NavIndex(0)">
								<span>最新发布</span>
								<span v-if="curTab0NavIndex===0" class="searchItemActiveBar"></span>
							</div> -->
						</div>
						<div class="searchLineR">
							<el-input v-model="search1.keyword" @keyup.enter.native="changeSearch1"></el-input>
						</div>
					</div>
					<div class="list" v-if="$public.isNull(tableData1)" style="background-color: #fff;">
						<div style="padding-top:60px;text-align: center;">暂无数据</div>
					</div>
					<div class="list" v-else>
						<el-table :data="tableData1" >
							<el-table-column prop="no" label="序号" width="50">
								<template slot-scope="scope">
									{{scope.$index+1}}
								</template>
							</el-table-column>
							<el-table-column label="图片" width="60" >
								<template slot-scope="scope">
									<img :src="scope.row.image" style="max-width:40px;max-height:40px;"/>
								</template>
							</el-table-column>
							<el-table-column label="名称"  >
								<template slot-scope="scope">
									{{scope.row.petInfo&&scope.row.petInfo.nickName}}
								</template>
							</el-table-column>
							<el-table-column label="规格" width="100" >
								<template slot-scope="scope">
									{{scope.row.petInfo&&scope.row.petInfo.epromNo}}
								</template>
							</el-table-column>
							<el-table-column label="价格"  width="100">
								<template slot-scope="scope">
									{{scope.row.price}}
								</template>
							</el-table-column>
							<el-table-column label="数量"  width="100">
								<template slot-scope="scope">
									{{scope.row.num}}
								</template>
							</el-table-column>
							<el-table-column label="添加时间" width="160">
								<template slot-scope="scope">
									{{scope.row.createTime}}
								</template>
							</el-table-column>
						</el-table>
						<div class="pagePosi">
							<page style="padding:10px 0;" :page="page1.page" :total="page1.total" @change="changePage1"></page>
						</div>
					</div>
				</div>
				
			</div>
		</div>
		<!-- 内容详情 -->
		<div v-if="compContentDetail_state===true" style="width:100%;height: 100%;position: absolute;top:0;left:0;z-index: 5;background-color: #F5F5FA;padding:16px 16px;box-sizing: border-box;">
			<compContentDetail @submit="compContentDetail_state=false"></compContentDetail>
		</div>
	</div>
</template>

<script>
	import compContentDetail from "@/components/pinglun/compContentDetail.vue"
	import page from "@/components/page.vue"
	export default {
		components:{page,compContentDetail},
		data() {
			return {
				curNavIndex:0,
				
				// 内容详情弹出
				compContentDetail_state:false,
				// 商品
				search0:{
					keyword:'',
					sort:'',
				},
				page0:{
					page:1,
					pageSize:10,
					total:0
				},
				tableData0:[],
				// 活体 
				search1:{
					keyword:'',
					sort:'',
				},
				page1:{
					page:1,
					pageSize:10,
					total:0
				},
				tableData1:[],
				
				
				
			}
		},
		computed:{
			
		},
		props:{
			count:{
				default:()=>{return {}}
			}
		},
		created(){
			
		},
		mounted(){
			this.getTableData0List()
		},
		methods:{
			changeCurNavIndex(i){
				this.curNavIndex=i;
				if(i===0){this.getTableData0List()} // 商品
				if(i===1){this.getTableData1List()} // 活体 
			},
			see0(row){
				console.log(row)
			},
			see1(row){
				console.log(row)
			},
			
			// 内容弹窗
			toContentDetail(item){
				console.log(item)
				this.compContentDetail_state=true
			},
			// 关注
			changeSearch0(){
				this.page0.page=1;
				this.getTableData0List()
			},
			changePage0(num){
				this.page0.page=num;
				this.getTableData0List()
			},
			getTableData0List(){
				let params = {
					"keyWord": this.search0.keyword,
					"sort": "",
					"desc": true,
					"userId": this.$route.query.id,
					"goodsType": 0, //  -1全部 0商品 5活体
					"state": 0, // 0全部 1 正常 2 无货 3 已售卖 4 已下架
					"pageIndex": this.page0.page,
					"pageSize": this.page0.pageSize,
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_AppAdmin+'/api/CartInfo/GetCartInfoManageList', params).then(res => {
					loading.close();
					if (res.code == 0) {
						this.tableData0 = res.data.list||[];
						this.page0.total = res.data.count;
					}
				})
			},
			// 粉丝
			changeSearch1(){
				this.page1.page=1;
				this.getTableData1List()
			},
			changePage1(num){
				this.page1.page=num;
				this.getTableData1List()
			},
			getTableData1List(){
				let params = {
					"keyWord": this.search1.keyword,
					"sort": "",
					"desc": true,
					"userId": this.$route.query.id,
					"goodsType": 5, //  -1全部 0商品 5活体
					"state": 0, // 0全部 1 正常 2 无货 3 已售卖 4 已下架
					"pageIndex": this.page1.page,
					"pageSize": this.page1.pageSize,
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_AppAdmin+'/api/CartInfo/GetCartInfoManageList', params).then(res => {
					loading.close();
					if (res.code == 0) {
						this.tableData1 = res.data.list||[];
						this.page1.total = res.data.count;
					}
				})
			},
			
		},
	}
</script>

<style lang="scss" scoped>
	.comp{
		display: flex;margin-top:16px;height: 100%;
		.L{
			width:272px;background-color: #fff;border-radius: 16px;flex-shrink: 0;padding:24px;box-sizing: border-box;margin-right: 16px;overflow: auto;
			.LItem{
				line-height: 36px;display: flex;color:$color333;font-size: 14px;font-weight: bold;cursor: pointer;margin-bottom: 10px;
				&.active{
					color:#577BFF;background-color: #F6F8FF;
				}
				.navLabel{
					width:50%;text-align: center;
				}
				.navValue{
					width:50%;text-align: center;
				}
			}
		}
		.R{
			width:100%;
			.panel{
				position: relative;height: 100%;
				.searchLine{
					display: flex;justify-content: space-between;background-color: #fff;border-radius: 16px 16px 0px 0px;padding:20px 32px 20px;position: absolute;width:100%;box-sizing: border-box;top:0;z-index: 1;
					.searchLineL{
						display: flex;padding-top: 16px;
						.searchItem{
							font-size: 14px;color:$color333;margin-right: 40px;cursor: pointer;
							&.active{
								color:#577BFF;
							}
							.searchItemActiveBar{
								display: block;width:18px;height: 4px;background: linear-gradient(135deg, #4BB2FF 0%, #466BFF 100%);border-radius: 3px;margin:8px auto 0;
							}
						}
					}
					.searchLineR{
						
					}
				}
				.list{
					padding-top:80px;border-radius: 16px;overflow: auto;height: calc(100% - 80px);background-color: #fff;
					.item{
						background-color: #fff;border-radius: 16px;margin-bottom:16px;padding:32px;display: flex;
						.avatarBox{
							.avatar{
								width:56px;height: 56px;border-radius: 50%;margin-right: 16px;
							}
						}
						.avatarBoxR{
							.originalName{
								font-size: 14px;color:$color333;padding-bottom:5px
							}
							.originalTime{
								font-size: 12px;color:$color999;
							}
							.originalTag{
								display: flex;padding-top:10px;
								.tagItem{
									background-color: #F7F9FA;border-radius: 12px;margin-right: 20px;display: flex;height: 22px;padding:3px 10px 3px 3px;box-sizing: border-box;line-height: 16px;
									.tagIcon{
										width:16px;height: 16px;margin-right: 5px;
									}
									.tagText{
										font-size: 12px;color:#4062E7;
									}
								}
							}
							.originalWord{
								padding-top:10px;padding-right: 50px;
								.word{
									font-size: 14px;color:$color333;line-height: 22px;
								}
							}
							.originalImg{
								padding-top:10px;padding-right: 30px;overflow: hidden;white-space: nowrap;width:625px;
								.originalImgItem{
									width:104px;height: 104px;margin-right: 4px;
								}
							}
							.originalBtn{
								display: flex;padding-top:16px;
								.num1{
									font-size: 14px;color:#333;margin-right: 16px;
								}
								.num2{
									font-size: 14px;color:$color999;margin-right: 32px;
								}
								.btn{
									font-size: 14px;color:#577BFF;margin-right: 32px;cursor: pointer;
								}
							}
						}
					}
				}
				.list1{
					padding:62px 32px 0 32px;display: flex;flex-wrap: wrap;background-color: #fff;border-radius: 16px;overflow: auto;max-height: calc(100% - 68px);align-items: flex-start;
					.item1{
						width:256px;padding-top:32px;height: 238px;margin-right: 16px;
						.item1ImgBox{
							position: relative;font-size: 0;width:256px;
							.item1Img{
								width:255px;height: 144px;
							}
							.item1Time{
								line-height: 36px;color:#fff;text-align: right;padding:0 16px;background-color: rgba(0, 0, 0, 0.5);position: absolute;bottom:0;width:100%;left:0;box-sizing: border-box;font-size: 14px;
							}
						}
						.item1Desc{
							font-size: 14px;color:$color333;padding: 16px 0;display: flex;justify-content: space-between;
							.text{
								width:100%;padding-right: 20px;
							}
							.more{
								width:20px;height: 20px;cursor: pointer;flex-shrink: 0;
							}
						}
						.item1BtnBox{
							display: flex;flex-wrap: wrap;
							.item1Btn{
								font-size: 14px;color:$color333;width:50%;padding-bottom:10px;
								span{
									margin-right: 8px;
								}
							}
						}
					}
				}
				.list6{
					padding:62px 32px 0 32px;background-color: #fff;border-radius: 16px;overflow: auto;max-height: calc(100% - 68px);
					.item6{
						padding:32px 0 0;
						.item6Date{
							font-size: 18px;color:$color333;font-weight: 600;
						}
						.item6Content{
							padding:16px 0 0;flex-wrap: wrap;display: flex;
							.item6ImgBox{
								position: relative;font-size: 0;width:103px;margin-right: 4px;margin-bottom: 16px;border-radius: 4px;
								.item6Img{
									width:103px;height: 103px;
								}
								.item6Time{
									line-height:24px;color:#fff;text-align: center;background-color: rgba(0, 0, 0, 0.5);position: absolute;bottom:0;width:100%;left:0;box-sizing: border-box;font-size: 12px;
								}
							}
						}
						
					}
				}
			}
			.pagePosi{
				width:100%;text-align: right;background-color: #fff;border-radius: 8px;padding:0 10px;box-sizing: border-box;position: relative;z-index: 1;
			}
		}
	}
</style>
